import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Flex, Popover, PopoverAnchor } from '@chakra-ui/react';
import { useDatePicker } from '../DatePickerContext';
import { DatePickerInput } from './DatePickerInput';
import { DatePickerOverlay } from './DatePickerOverlay';
export const DatePickerWrapper = ({ children }) => {
    const { disclosureProps, initialFocusRef, closeCalendarOnChange, isMobile, inputElement, } = useDatePicker();
    const inputToRender = useMemo(() => {
        return inputElement ?? _jsx(DatePickerInput, {});
    }, [inputElement]);
    if (isMobile) {
        return (_jsxs(Flex, { children: [inputToRender, children] }));
    }
    return (_jsxs(Flex, { children: [_jsxs(Popover, { placement: "bottom-start", isLazy: true, initialFocusRef: initialFocusRef, closeOnBlur: closeCalendarOnChange, returnFocusOnClose: false, ...disclosureProps, children: [_jsx(PopoverAnchor, { children: inputToRender }), children] }), _jsx(DatePickerOverlay, {})] }));
};
